import React, { useRef, useState } from 'react';
import { Check, ArrowRight, Info, X as LucideX } from 'lucide-react';
import ReactDOM from 'react-dom';

function WordPressIconImg({ size = 22, className = '' }) {
  return <img src="/icons/wordpress.svg" width={size} height={size} alt="WordPress" className={className} />;
}

const PLAN_ICONS_WORDPRESS = {
  'Wordpress Start': WordPressIconImg,
  'Wordpress Pro': WordPressIconImg,
  'Wordpress Max': WordPressIconImg
};

// --- BENEFÍCIOS E SEÇÕES ---
const WORDPRESS_PLAN_BENEFITS = [
  // Seção inicial (sem título)
  { section: null, text: '1 site', preview: 'Hospede um site WordPress com todos os recursos do plano.', showInfo: false, plans: ['Wordpress Start'] },
  { section: null, text: 'Domínio grátis', preview: 'Registre um domínio gratuitamente para seu site.', showInfo: true, plans: ['Wordpress Start'], unavailable: true },
  { section: null, text: '50 sites', preview: 'Hospede até 50 sites WordPress com todos os recursos do plano.', showInfo: false, plans: ['Wordpress Pro'] },
  { section: null, text: '100 sites', preview: 'Hospede até 100 sites WordPress com todos os recursos do plano.', showInfo: false, plans: ['Wordpress Max'] },
  { section: null, text: 'Domínio grátis', preview: 'Registre um domínio gratuitamente para seu site.', showInfo: true, plans: ['Wordpress Pro', 'Wordpress Max'], unavailable: false },
  { section: null, text: '10 GB de armazenamento NVMe ultrarrápido', preview: 'Espaço suficiente para seu site WordPress, fotos, vídeos e arquivos, com tecnologia de alta velocidade.', showInfo: true, plans: ['Wordpress Start'] },
  { section: null, text: '50 GB de armazenamento NVMe ultrarrápido', preview: 'Muito espaço e velocidade para sites WordPress profissionais.', showInfo: true, plans: ['Wordpress Pro'] },
  { section: null, text: '100 GB de armazenamento NVMe ultrarrápido', preview: 'Espaço máximo e velocidade para grandes projetos WordPress.', showInfo: true, plans: ['Wordpress Max'] },
  { section: null, text: 'Suporte para até 20.000 visitantes por mês', preview: 'Seu site pode receber até 20 mil acessos mensais sem perder desempenho.', showInfo: true, plans: ['Wordpress Start'] },
  { section: null, text: 'Suporte para até 100.000 visitantes por mês', preview: 'Seu site pode receber até 100 mil acessos mensais com desempenho.', showInfo: true, plans: ['Wordpress Pro'] },
  { section: null, text: 'Suporte para até 200.000 visitantes por mês', preview: 'Seu site pode receber até 200 mil acessos mensais com desempenho.', showInfo: true, plans: ['Wordpress Max'] },
  { section: null, text: '1 caixa de e-mail profissional', preview: 'Crie um e-mail personalizado com o nome do seu site, como contato@seudominio.com.', showInfo: true, plans: ['Wordpress Start'] },
  { section: null, text: '5 caixas de e-mail profissional', preview: 'Crie até 5 e-mails personalizados para sua equipe.', showInfo: true, plans: ['Wordpress Pro'] },
  { section: null, text: '10 caixas de e-mail profissional', preview: 'Crie até 10 e-mails personalizados para sua equipe.', showInfo: true, plans: ['Wordpress Max'] },
  // WordPress & Sites
  { section: 'WordPress & Sites', text: '3 bancos de dados MySQL para sites e aplicações simples', preview: 'Permite instalar até 3 sistemas ou sites que precisam de banco de dados, como WordPress.', showInfo: true, plans: ['Wordpress Start'], upgrade: { text: 'Bancos de dados Ilimitados', plans: ['Wordpress Pro', 'Wordpress Max'] } },
  { section: 'WordPress & Sites', text: 'Instalação de WordPress e outros CMS com 1 clique', preview: 'Instale plataformas populares para criar seu site sem precisar de programação.', showInfo: false, plans: ['Wordpress Start', 'Wordpress Pro', 'Wordpress Max'] },
  { section: 'WordPress & Sites', text: 'Criador de sites Hostul incluso', preview: 'Monte seu site arrastando blocos, sem precisar saber programar.', showInfo: false, plans: ['Wordpress Start', 'Wordpress Pro', 'Wordpress Max'] },
  { section: 'WordPress & Sites', text: 'Acesso a estatísticas de tráfego e uso em tempo real pelo painel', preview: 'Veja quantas pessoas visitam seu site e acompanhe o uso dos recursos.', showInfo: false, plans: ['Wordpress Start', 'Wordpress Pro', 'Wordpress Max'] },
  // Segurança
  { section: 'Segurança', text: 'Certificado SSL gratuito (Let\'s Encrypt)', preview: 'Garante que seu site seja seguro e confiável para os visitantes, ativando o cadeado de segurança.', showInfo: true, plans: ['Wordpress Start', 'Wordpress Pro', 'Wordpress Max'] },
  { section: 'Segurança', text: 'Backups semanais', preview: 'Seu site é salvo automaticamente toda semana, protegendo contra perdas de dados.', showInfo: false, plans: ['Wordpress Start'], upgrade: { text: 'Backups Diários', plans: ['Wordpress Pro', 'Wordpress Max'] } },
  { section: 'Segurança', text: 'Proteção básica contra ataques DDoS e monitoramento de disponibilidade 24/7', preview: 'Seu site fica protegido contra ataques e é monitorado o tempo todo para evitar quedas.', showInfo: true, plans: ['Wordpress Start', 'Wordpress Pro', 'Wordpress Max'] },
  { section: 'Segurança', text: 'Proteção contra spam e antivírus para a conta de e-mail', preview: 'Seus e-mails ficam protegidos contra mensagens indesejadas e vírus.', showInfo: false, plans: ['Wordpress Start', 'Wordpress Pro', 'Wordpress Max'] },
  // Suporte
  { section: 'Suporte', text: 'Suporte técnico especializado 24/7 via chat e ticket', preview: 'Ajuda disponível a qualquer hora, todos os dias, para resolver dúvidas e problemas.', showInfo: false, plans: ['Wordpress Start', 'Wordpress Pro', 'Wordpress Max'] },
  { section: 'Suporte', text: 'Painel de controle exclusivo Hostul', preview: 'Gerencie seu site, e-mails e recursos de forma fácil, mesmo sem experiência técnica.', showInfo: true, plans: ['Wordpress Start', 'Wordpress Pro', 'Wordpress Max'] },
  // Recursos Técnicos
  { section: 'Recursos Técnicos', text: 'CDN Grátis', preview: 'Seu site é distribuído globalmente para carregar mais rápido em qualquer lugar.', showInfo: true, plans: ['Wordpress Start', 'Wordpress Pro', 'Wordpress Max'] },
  { section: 'Recursos Técnicos', text: 'Recursos de cache e otimização de desempenho integrados', preview: 'Seu site carrega mais rápido, melhorando a experiência dos visitantes.', showInfo: false, plans: ['Wordpress Start', 'Wordpress Pro', 'Wordpress Max'] },
  { section: 'Recursos Técnicos', text: 'Contas FTP e Gerenciador de Arquivos avançado para administração completa', preview: 'Envie, organize e edite arquivos do seu site facilmente.', showInfo: false, plans: ['Wordpress Start', 'Wordpress Pro', 'Wordpress Max'] },
  { section: 'Recursos Técnicos', text: 'Gerenciador de DNS completo para configurar subdomínios e registros facilmente', preview: 'Controle endereços e subdomínios do seu site de forma simples.', showInfo: false, plans: ['Wordpress Start', 'Wordpress Pro', 'Wordpress Max'] },
];

const WORDPRESS_EXTRA_FEATURES = [
  { text: 'Migração gratuita de site', preview: 'Transferimos seu site de outro provedor para a Hostul sem custo.', showInfo: true, plans: ['Wordpress Pro', 'Wordpress Max'] },
  { text: 'Ambiente seguro com isolamento de recursos', preview: 'Seu site fica protegido de outros clientes no mesmo servidor.', showInfo: true, plans: ['Wordpress Start', 'Wordpress Pro', 'Wordpress Max'] },
  { text: 'Atualizações automáticas de segurança', preview: 'Seu ambiente recebe correções de segurança automaticamente.', showInfo: true, plans: ['Wordpress Pro', 'Wordpress Max'] },
  { text: 'Suporte a PHP, Node.js e Python', preview: 'Hospede sites e aplicações em diferentes linguagens.', showInfo: true, plans: ['Wordpress Max'] },
  { text: 'Acesso SSH sob demanda', preview: 'Tenha acesso avançado ao servidor para tarefas técnicas.', showInfo: true, plans: ['Wordpress Max'] },
  { text: 'Monitoramento de performance em tempo real', preview: 'Acompanhe o desempenho do seu site pelo painel.', showInfo: true, plans: ['Wordpress Pro', 'Wordpress Max'] },
  { text: 'Ferramentas de SEO integradas', preview: 'Recursos para melhorar o posicionamento do seu site no Google.', showInfo: true, plans: ['Wordpress Pro', 'Wordpress Max'] },
  { text: 'Garantia de uptime 99,9%', preview: 'Seu site sempre disponível, com alta confiabilidade.', showInfo: true, plans: ['Wordpress Start', 'Wordpress Pro', 'Wordpress Max'] },
];

const planSubtitles = {
  'Wordpress Start': 'Para começar seu site WordPress com economia.',
  'Wordpress Pro': 'Para crescer com performance no WordPress.',
  'Wordpress Max': 'Para máxima liberdade e recursos no WordPress.'
};

const prices48 = {
  'Wordpress Start': '14,90',
  'Wordpress Pro': '29,90',
  'Wordpress Max': '59,90'
};
const oldPrices = {
  'Wordpress Start': 'R$39,90/mês',
  'Wordpress Pro': 'R$79,90/mês',
  'Wordpress Max': 'R$149,90/mês'
};
const savings = {
  'Wordpress Start': 'ECONOMIZE 63%',
  'Wordpress Pro': 'ECONOMIZE 62%',
  'Wordpress Max': 'ECONOMIZE 60%'
};
const planRenewalSubtitles = {
  'Wordpress Start': '48 meses por apenas R$ 715,20 (normal R$ 1.915,20). Renovação por R$ 29,90/mês*',
  'Wordpress Pro': '48 meses por apenas R$ 1.435,20 (normal R$ 3.835,20). Renovação por R$ 74,90/mês*',
  'Wordpress Max': '48 meses por apenas R$ 2.875,20 (normal R$ 7.195,20). Renovação por R$ 139,90/mês*'
};

function getPlanSections(plan) {
  const sectionTitles = [null, 'WordPress & Sites', 'Segurança', 'Suporte', 'Recursos Técnicos'];
  return sectionTitles.map(title => {
    const items = WORDPRESS_PLAN_BENEFITS.filter(b => {
      if (b.section !== title) return false;
      if (b.plans && !b.plans.includes(plan)) return false;
      return true;
    }).map(b => {
      let text = b.text;
      if (b.upgrade && b.upgrade.plans.includes(plan)) text = b.upgrade.text;
      let unavailable = b.unavailable || false;
      if (b.plans && !b.plans.includes(plan)) unavailable = true;
      return { ...b, text, unavailable };
    });
    return { title, items };
  });
}

function getExtraFeatures(plan) {
  return WORDPRESS_EXTRA_FEATURES.map(f => ({
    ...f,
    unavailable: !f.plans.includes(plan)
  }));
}

function TooltipInfo({ info, alignRef }) {
  const [show, setShow] = useState(false);
  const [tooltipPos, setTooltipPos] = useState(null);
  const ref = React.useRef();
  React.useEffect(() => {
    if (show && alignRef && alignRef.current) {
      const alignRect = alignRef.current.getBoundingClientRect();
      const minWidth = 180;
      const maxWidth = 260;
      let top = alignRect.top + alignRect.height / 2;
      let left = alignRect.right + 8;
      let tooltipWidth = Math.min(window.innerWidth - left - 16, maxWidth);
      if (tooltipWidth < minWidth) tooltipWidth = minWidth;
      if (left + tooltipWidth > window.innerWidth - 8) {
        left = window.innerWidth - tooltipWidth - 8;
      }
      if (left < 8) left = 8;
      setTooltipPos({ left, top: top - 20, width: tooltipWidth });
    } else {
      setTooltipPos(null);
    }
  }, [show, alignRef]);
  return (
    <span className="relative ml-1">
      <span
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
        tabIndex={0}
        onFocus={() => setShow(true)}
        onBlur={() => setShow(false)}
        className="inline-flex"
        ref={alignRef}
      >
        <Info size={14} className="text-purple-400 cursor-pointer hover:text-purple-700" />
      </span>
      {show && tooltipPos && ReactDOM.createPortal(
        <span
          ref={ref}
          className="bg-white text-gray-900 text-xs rounded-lg px-3 py-2 shadow-lg whitespace-normal border border-purple-700"
          style={{
            position: 'fixed',
            left: tooltipPos.left,
            top: tooltipPos.top,
            minWidth: 180,
            maxWidth: 260,
            width: tooltipPos.width,
            zIndex: 9999,
            whiteSpace: 'normal',
            pointerEvents: 'none',
            transform: 'translateY(-50%)',
            boxShadow: '0 6px 32px 0 rgba(80, 0, 120, 0.18)',
          }}
        >
          {info}
        </span>,
        document.body
      )}
    </span>
  );
}

function WordpressPricingPlan({ title, price48, oldPrices, savings, planRenewalSubtitles, icon: Icon, showExtras, onToggleExtras, scrollToTitleRef }) {
  const planSections = getPlanSections(title);
  const extraList = getExtraFeatures(title);
  const sectionRefs = useRef(planSections.map(section => section.items.map(() => React.createRef())));
  const extraRefs = useRef(extraList.map(() => React.createRef()));
  const cardRef = useRef();
  const isPro = title === 'Wordpress Pro';
  const buttonText = isPro ? 'Quero o Pro' : 'Quero este plano';
  const buttonClass = isPro
    ? 'w-full py-3 px-4 rounded-xl font-semibold text-white transition-all duration-300 bg-gradient-to-r from-purple-600 to-indigo-600 shadow-lg hover:from-purple-700 hover:to-indigo-700 focus:outline-none focus:ring-2 focus:ring-purple-400 text-sm md:text-base flex justify-center items-center mb-1 mt-1 scale-105'
    : 'w-full py-3 px-4 rounded-xl font-semibold text-purple-400 border-2 border-purple-600 transition-all duration-300 bg-transparent hover:bg-purple-900/10 hover:text-white focus:outline-none focus:ring-2 focus:ring-purple-400 text-sm md:text-base flex justify-center items-center mb-1 mt-1';
  return (
    <div ref={cardRef} className={`rounded-2xl overflow-hidden bg-gradient-to-b from-gray-900 via-gray-950 to-gray-900 border border-purple-900 shadow-xl relative z-10 group focus-within:ring-2 focus-within:ring-purple-400`}>
      <div className="h-2 w-full bg-gradient-to-r from-purple-500 via-indigo-500 to-purple-700" />
      <div className="relative m-[2px] rounded-2xl bg-transparent h-full flex flex-col">
        <div className="p-6 md:p-7 flex-1 flex flex-col">
          <div className="flex items-center mb-1">
            <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center bg-gradient-to-br from-purple-700 to-indigo-700 shadow-lg">
              <Icon size={22} className="text-white" />
            </div>
            <h3 className="text-lg md:text-xl font-bold text-white ml-3 tracking-tight drop-shadow-sm">{title}</h3>
          </div>
          <div className="text-xs md:text-sm text-purple-200 font-medium mb-3 ml-1 md:ml-0 mt-2">{planSubtitles[title]}</div>
          <div className="flex flex-col items-start mb-4 mt-2 relative h-auto w-full">
            <div className="flex items-center mb-1">
              <span className="text-base md:text-lg text-gray-400 line-through mr-2 select-none">{oldPrices[title]}</span>
              <span className="px-2.5 py-1 rounded-full bg-gradient-to-r from-purple-600 to-indigo-500 text-white text-xs font-bold shadow-sm border border-purple-400/40 tracking-wide uppercase" style={{letterSpacing: '0.04em'}}>{savings[title]}</span>
            </div>
            <span className="text-3xl md:text-4xl font-bold text-purple-300 leading-tight flex items-baseline">
              <span className="text-base md:text-lg text-purple-200 mr-0.5">R$</span>{price48}<span className="text-xs md:text-sm text-gray-400 ml-0.5 font-normal">/mês</span>
            </span>
            <span className="text-[11px] md:text-xs text-gray-400 font-normal mt-1 mb-2 block">Preço estimado considerando o ciclo promocional de 48 meses.</span>
          </div>
          <button className={buttonClass}>{buttonText} <ArrowRight size={15} className="ml-2" /></button>
          <div className="text-[8.5px] md:text-[10px] text-gray-400 font-normal mt-1 mb-4 text-left w-full">{planRenewalSubtitles[title]}</div>
          <hr className="border-t border-gray-700/60 my-4 mb-5 w-full" />
          {/* Lista de recursos */}
          {(() => {
            const firstTitledSectionIdx = planSections.findIndex(s => s.title);
            return planSections.map((section, sidx) => {
              const sectionTitleClass = `text-xs uppercase tracking-wider text-purple-300 font-bold ${sidx === firstTitledSectionIdx ? 'mt-5' : 'mt-0'} mb-2`;
              return (
                <React.Fragment key={sidx}>
                  {section.title && <div className={sectionTitleClass}>{section.title}</div>}
                  <ul className="space-y-2 mb-5 flex-1">
                    {section.items.map((feature, index) => {
                      const ref = sectionRefs.current[sidx] ? sectionRefs.current[sidx][index] : undefined;
                      const unavailable = feature.unavailable;
                      return (
                        <li key={section.title + '-' + index} className={`flex items-start text-[15px] font-medium relative ${unavailable ? 'text-gray-500 line-through opacity-60' : 'text-gray-100'}`}> 
                          <div className={`p-1 rounded-full mt-0.5 mr-2 flex-shrink-0 flex items-center justify-center ${unavailable ? 'bg-gray-700' : 'bg-gradient-to-br from-purple-800/80 to-indigo-900/80'}`}>{unavailable ? <LucideX size={13} className="text-red-400" /> : <Check size={13} className="text-purple-300" />}</div>
                          <span className="flex items-center gap-1">
                            <span ref={ref}>{feature.text}</span>
                            {feature.showInfo && feature.preview && !unavailable && <TooltipInfo info={feature.preview} alignRef={ref} />}
                          </span>
                        </li>
                      );
                    })}
                  </ul>
                </React.Fragment>
              );
            });
          })()}
          {showExtras && (
            <>
              <div className="text-xs uppercase tracking-wider text-purple-300 font-bold mt-5 mb-2">Benefícios Extras</div>
              <ul className="space-y-2 mb-5 flex-1">
                {extraList.map((feature, idx) => {
                  const ref = extraRefs.current[idx] || undefined;
                  return (
                    <li key={feature.text + '-' + idx} className={`flex items-start text-[15px] font-medium relative ${feature.unavailable ? 'text-gray-500 line-through opacity-60' : 'text-gray-300'}`}> 
                      <div className={`p-1 rounded-full mt-0.5 mr-2 flex-shrink-0 flex items-center justify-center ${feature.unavailable ? 'bg-gray-700' : 'bg-gradient-to-br from-purple-900/80 to-indigo-900/80'}`}>{feature.unavailable ? <LucideX size={13} className="text-red-400" /> : <Check size={13} className="text-purple-400" />}</div>
                      <span className="flex items-center gap-1">
                        <span ref={ref}>{feature.text}</span>
                        {feature.showInfo && feature.preview && !feature.unavailable && <TooltipInfo info={feature.preview} alignRef={ref} />}
                      </span>
                    </li>
                  );
                })}
              </ul>
            </>
          )}
        </div>
        <button
          onClick={onToggleExtras}
          className="block w-full py-2.5 px-4 pb-5 text-center leading-none bg-gray-900/80 text-purple-300 text-xs font-semibold cursor-pointer rounded-b-2xl border-t border-purple-800 transition-colors hover:bg-purple-950/90"
        >
          {showExtras ? 'Ocultar benefícios' : 'Ver mais benefícios'}
        </button>
      </div>
    </div>
  );
}

export default function WordpressPricingSection() {
  const [showExtras, setShowExtras] = useState(false);
  const titleRef = useRef();
  return (
    <section id="planos-wordpress" className="py-20 md:py-24 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-gray-950 via-purple-950 to-gray-900 opacity-95"></div>
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute inset-0 bg-[radial-gradient(#a78bfa_1px,transparent_1px)] [background-size:30px_30px] opacity-10"></div>
        <div className="absolute top-32 left-1/4 w-80 h-80 bg-purple-700 rounded-full filter blur-[120px] opacity-20"></div>
        <div className="absolute bottom-32 right-1/4 w-80 h-80 bg-indigo-700 rounded-full filter blur-[120px] opacity-20"></div>
      </div>
      <div className="container mx-auto px-2 md:px-4 relative z-10">
        <div className="text-center mb-8 md:mb-10">
          <h2 ref={titleRef} className="text-2xl md:text-4xl font-bold mb-2 md:mb-4 text-white">
            <span className="bg-gradient-to-r from-purple-400 to-indigo-400 text-transparent bg-clip-text">
              Planos Wordpress Profissionais
            </span>
          </h2>
          <p className="text-base md:text-xl text-gray-300 max-w-3xl mx-auto mb-10 md:mb-16">
            Escolha o plano ideal para seu site WordPress com performance, segurança e suporte especializado.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-8 max-w-6xl mx-auto">
          <div className="flex flex-col md:mt-4">
            <WordpressPricingPlan
              title="Wordpress Start"
              price48={prices48['Wordpress Start']}
              oldPrices={oldPrices}
              savings={savings}
              planRenewalSubtitles={planRenewalSubtitles}
              icon={PLAN_ICONS_WORDPRESS['Wordpress Start']}
              showExtras={showExtras}
              onToggleExtras={() => setShowExtras(v => !v)}
              scrollToTitleRef={titleRef}
            />
          </div>
          <div className="flex flex-col items-center">
            <div className="mb-2 -mt-4 relative">
              <span className="inline-block px-4 py-1 rounded-full bg-gradient-to-r from-purple-600 to-indigo-600 text-white text-xs font-bold shadow-md tracking-wide uppercase flash-effect">Escolha Recomendada</span>
              <style>{`
                .flash-effect {
                  position: relative;
                  overflow: hidden;
                }
                .flash-effect::after {
                  content: '';
                  position: absolute;
                  top: 0; left: -70%;
                  width: 80%; height: 100%;
                  background: linear-gradient(100deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.18) 30%, rgba(255,255,255,0.45) 50%, rgba(255,255,255,0.18) 70%, rgba(255,255,255,0) 100%);
                  filter: blur(2px);
                  transform: skewX(-18deg);
                  animation: flash-move 2.5s cubic-bezier(0.4,0,0.2,1) infinite;
                  pointer-events: none;
                }
                @keyframes flash-move {
                  0% { left: -70%; }
                  100% { left: 110%; }
                }
              `}</style>
            </div>
            <WordpressPricingPlan
              title="Wordpress Pro"
              price48={prices48['Wordpress Pro']}
              oldPrices={oldPrices}
              savings={savings}
              planRenewalSubtitles={planRenewalSubtitles}
              icon={PLAN_ICONS_WORDPRESS['Wordpress Pro']}
              showExtras={showExtras}
              onToggleExtras={() => setShowExtras(v => !v)}
              scrollToTitleRef={titleRef}
            />
          </div>
          <div className="flex flex-col md:mt-4">
            <WordpressPricingPlan
              title="Wordpress Max"
              price48={prices48['Wordpress Max']}
              oldPrices={oldPrices}
              savings={savings}
              planRenewalSubtitles={planRenewalSubtitles}
              icon={PLAN_ICONS_WORDPRESS['Wordpress Max']}
              showExtras={showExtras}
              onToggleExtras={() => setShowExtras(v => !v)}
              scrollToTitleRef={titleRef}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
